import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { StorageService } from './storage.service';
import { Fazenda } from '../classes/Fazenda';

@Injectable({
  providedIn: 'root'
})
export class FazendaService {

  public fazendaSelecionada: Fazenda;

  private fazendasCache$: Observable<any> | null = null;
  constructor(private http: HttpClient) { }

  getFazendas(): Observable<any>{
    if (!this.fazendasCache$) {
      this.fazendasCache$ = this.http.get(`${environment.apiURL}/fazendas/Ativos`).pipe(shareReplay(1));
    }
    return this.fazendasCache$;
  }

  getTodasFazendas(): Observable<any>{
    return this.http.get(`${environment.apiURL}/fazendas`)
  }

  getFazenda(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/fazendas/${id}`)
  }

  postFazenda(fazenda: Fazenda): Observable<any>{
    this.fazendasCache$ = null;
    return this.http.post(`${environment.apiURL}/fazendas`, fazenda);
  }

  putFazenda(id: number, fazenda: Fazenda): Observable<any>{
    this.fazendasCache$ = null;
    return this.http.put(`${environment.apiURL}/fazendas/${id}`, fazenda);
  }

  deleteFazenda(id: number): Observable<any>{
    this.fazendasCache$ = null;
    return this.http.delete(`${environment.apiURL}/fazendas/${id}`);
  }

  duplicar(ids: number[]): Observable<any>{
    this.fazendasCache$ = null;
    return this.http.post(`${environment.apiURL}/fazendas/duplicar`, ids);
  }

  inativar(ids: number[]): Observable<any>{
    this.fazendasCache$ = null;
    return this.http.put(`${environment.apiURL}/fazendas/inativar`, ids);
  }

  deleteFazendas(ids: number[]): Observable<any>{
    this.fazendasCache$ = null;
    const params = ids.map(id => `ids=${id}`).join('&');
    return this.http.delete(`${environment.apiURL}/fazendas?${params}`);
  }
}
